<script setup>
import { storeToRefs } from "pinia";
import {
  StealieHeading,
  StealieButton,
  StealieParagraph,
  StealieText,
} from "@get-overalls/fe-stealie";
import { useUserStore } from "@/stores/user";
import AuthenticatedLayout from "@/layouts/AuthenticatedLayout.vue";
import ContentPanel from "@/components/ContentPanel.vue";

const userStore = useUserStore();
const { user } = storeToRefs(userStore);
</script>

<template>
  <AuthenticatedLayout>
    <ContentPanel>
      <StealieHeading level="1">Account</StealieHeading>
      <h2 class="mt-8 mb-4 text-2xl font-bold">Basics</h2>
      <ul class="divide-y divide-brand-gray-50">
        <li class="flex items-center justify-between px-2 py-4 sm:px-4">
          <div>
            <StealieParagraph bold>Owner</StealieParagraph>
            <StealieParagraph>{{ user?.full_name }}</StealieParagraph>
          </div>
          <StealieButton variant="tertiary" @click="userStore.signOut"
            >Sign Out</StealieButton
          >
        </li>
        <li>
          <a
            href="mailto:help@getoveralls.com"
            class="group flex flex-col justify-between gap-4 px-2 py-4 sm:flex-row sm:items-center sm:px-4"
          >
            <div>
              <StealieParagraph bold>Contact Overalls Support</StealieParagraph>
              <StealieParagraph>
                For questions or feedback regarding the application itself
              </StealieParagraph>
            </div>
            <StealieText
              bold
              class="text-brand-primary-teal-400 group-hover:text-brand-primary-teal-300"
              aria-hidden="true"
            >
              help@getoveralls.com
            </StealieText>
          </a>
        </li>
      </ul>
      <h2 class="mt-8 mb-4 text-2xl font-bold">Data &amp; Privacy</h2>
      <ul class="divide-y divide-brand-gray-50">
        <li>
          <a
            href="mailto:help@getoveralls.com?subject=Close%20my%20account"
            class="group flex flex-col justify-between gap-4 px-2 py-4 sm:flex-row sm:items-center sm:px-4"
          >
            <div>
              <StealieParagraph bold>Close Account</StealieParagraph>
              <StealieParagraph>This action cannot be undone</StealieParagraph>
            </div>
            <StealieText
              bold
              class="text-brand-primary-teal-400 group-hover:text-brand-primary-teal-300"
              aria-hidden="true"
            >
              help@getoveralls.com
            </StealieText>
          </a>
        </li>
      </ul>
    </ContentPanel>
  </AuthenticatedLayout>
</template>
